export default __webpack_public_path__ + "static/media/AdamRzymski-TM129_21B_Introd-certificate.b5951037.pdf";